const MATERIAL_DECIMAL_FACTOR = 1000;

export const truncateTo3 = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined;

  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return undefined;

  return Math.trunc(numeric * MATERIAL_DECIMAL_FACTOR) / MATERIAL_DECIMAL_FACTOR;
};

export const hasMoreThan3Decimals = (value: unknown): boolean => {
  if (value === null || value === undefined || value === '') return false;
  const [, decimals = ''] = String(value).split('.');
  return decimals.length > 3;
};

export const formatDecimal3 = (value: unknown, fallback = '-'): string => {
  const normalized = truncateTo3(value);
  return normalized === undefined ? fallback : normalized.toFixed(3);
};

export const formatMoney3 = (value: unknown, fallback = '-'): string => {
  const normalized = truncateTo3(value);
  return normalized === undefined ? fallback : `¥${normalized.toFixed(3)}`;
};

export const calculateMaterialTotal3 = (quantity: unknown, unitPrice: unknown): number | undefined => {
  const normalizedQuantity = truncateTo3(quantity);
  const normalizedUnitPrice = truncateTo3(unitPrice);

  if (normalizedQuantity === undefined || normalizedUnitPrice === undefined) {
    return undefined;
  }

  return truncateTo3(normalizedQuantity * normalizedUnitPrice);
};

export const normalizeMaterialPrecision = <T extends {
  quantity?: unknown;
  unitPrice?: unknown;
  price?: unknown;
  totalPrice?: unknown;
  totalCost?: unknown;
  paymentAmount?: unknown;
}>(material: T): T => {
  const normalized: any = { ...material };

  if ('quantity' in normalized) normalized.quantity = truncateTo3(normalized.quantity);
  if ('unitPrice' in normalized) normalized.unitPrice = truncateTo3(normalized.unitPrice);
  if ('price' in normalized) normalized.price = truncateTo3(normalized.price);
  if ('paymentAmount' in normalized) normalized.paymentAmount = truncateTo3(normalized.paymentAmount);

  const total = calculateMaterialTotal3(normalized.quantity, normalized.unitPrice);
  if ('totalPrice' in normalized) {
    normalized.totalPrice = total ?? truncateTo3(normalized.totalPrice);
  } else if ('totalCost' in normalized || total !== undefined) {
    normalized.totalCost = total ?? truncateTo3(normalized.totalCost);
  }

  return normalized;
};
